const state = {
  card: {
    chave: null,
    titulo: null,
    buscarDados: null
  },
  categoria_selecionada: null,
  categorias_para_vincular_a_grupos_produtos: [],
  callbackAtualizarGridCategorias: () => {
    throw new Error('função ainda não referenciada!');
  },
  callbackAtualizarCardsTotais: () => {
    throw new Error('função ainda não referenciada!');
  },
  callbackAtualizarDetalhesCategoria: () => {
    throw new Error('função ainda não referenciada!');
  },
  callbackAtualizarQtdeCategoriasSilenciadas: () => {
    throw new Error('função ainda não referenciada!');
  }
}

const getters = {
  card_ativo(state) {
    return state.card
  },
  categoria_selecionada(state) {
    return state.categoria_selecionada
  },
  callbackAtualizarGridCategorias(state) {
    return state.callbackAtualizarGridCategorias
  },
  callbackAtualizarCardsTotais(state) {
    return state.callbackAtualizarCardsTotais
  },
  callbackAtualizarDetalhesCategoria(state) {
    return state.callbackAtualizarDetalhesCategoria
  },
  callbackAtualizarCarrinhoCompra(state) {
    return state.callbackAtualizarCarrinhoCompra
  },
  categorias_para_vincular_a_grupos_produtos(state) {
    return state.categorias_para_vincular_a_grupos_produtos
  },
  callbackAtualizarQtdeCategoriasSilenciadas(state) {
    return state.callbackAtualizarQtdeCategoriasSilenciadas
  }
}

const mutations = {
  card_ativo(state, valor){
    state.card = valor
  },
  categoria_selecionada(state, valor){
    state.categoria_selecionada = valor
  },
  callbackAtualizarGridCategorias(state, valor){
    state.callbackAtualizarGridCategorias = valor
  },
  callbackAtualizarCardsTotais(state, valor){
    state.callbackAtualizarCardsTotais = valor
  },
  callbackAtualizarDetalhesCategoria(state, valor){
    state.callbackAtualizarDetalhesCategoria = valor
  },
  callbackAtualizarCarrinhoCompra(state, valor){
    state.callbackAtualizarCarrinhoCompra = valor
  },
  categorias_para_vincular_a_grupos_produtos(state, valor){
    state.categorias_para_vincular_a_grupos_produtos = valor
  },
  callbackAtualizarQtdeCategoriasSilenciadas(state, valor){
    state.callbackAtualizarQtdeCategoriasSilenciadas = valor
  }
}

const actions = {
  card_ativo: ({ commit }, valor) => {
    commit("card_ativo", valor)
  },
  categoria_selecionada: ({ commit }, valor) => {
    commit("categoria_selecionada", valor)
  },
  callbackAtualizarGridCategorias(context, payload) {
    if (typeof payload !== 'function') {
      throw new Error(`${payload} deve ser a função que atualiza o grid de categorias a comprar!`);
    }

    context.commit("callbackAtualizarGridCategorias", payload);
  },
  callbackAtualizarCardsTotais(context, payload) {
    if (typeof payload !== 'function') {
      throw new Error(`${payload} deve ser a função que atualiza o grid de categorias a comprar!`);
    }

    context.commit("callbackAtualizarCardsTotais", payload);
  },
  callbackAtualizarDetalhesCategoria(context, payload) {
    if (typeof payload !== 'function') {
      throw new Error(`${payload} deve ser a função que atualiza o detalhes da categoria!`);
    }

    context.commit("callbackAtualizarDetalhesCategoria", payload);
  },
  callbackAtualizarCarrinhoCompra(context, payload) {
    if (typeof payload !== 'function') {
      throw new Error(`${payload} deve ser a função que atualiza o carrinho de compras!`);
    }

    context.commit("callbackAtualizarCarrinhoCompra", payload);
  },
  categorias_para_vincular_a_grupos_produtos(context, payload) {
    context.commit("categorias_para_vincular_a_grupos_produtos", payload);
  },
  callbackAtualizarQtdeCategoriasSilenciadas(context, payload) {
    context.commit("callbackAtualizarQtdeCategoriasSilenciadas", payload);
  },
}

export default { namespaced: true, state, mutations, getters, actions }
